import React from "react";

export default function Footer() {
  return (
    <nav className="navbar">
      <h4 className="nav-text">Developed by Fulya Ertay</h4>
    </nav>
  );
}
